import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiAddLeasingPlan } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useAddLeasingPlanMutation = () => {
    const segment = useSegment();
    const { cartId } = useCartQuery();

    const { mutate, isPending, error } = useMutationWithCartRefresh(
        async (leasingPlanCode: string) => {
            const { data: cart } = await apiAddLeasingPlan(segment, { cartId }, leasingPlanCode);

            return cart;
        },
        {
            mutationKey: [ESHOP_MUTATION_KEY.ADD_LEASING_PLAN],
        },
    );

    return {
        addLeasingPlan: mutate,
        addLeasingPlanIsLoading: isPending,
        addLeasingPlanError: error,
    };
};
